<template>
  <div>
    <div
      style="height:190px;overflow:auto"
      class="d-flex flex-column justify-content-end"
    >
      <vue-custom-scrollbar
        id="notes-container"
        style="height: 100%"
      >
        <div :class="$style.contentWrapper">
          <div
            v-for="(note, index) in notes"
            :key="index"
            :class="$style.message"
          >
            <div
              class="mb-2"
              :class="$style.messageContent"
            >
              <div>{{ note.note }}</div>
            </div>
          </div>
          <a-empty v-if="!notes || notes.length < 1" />
        </div>
      </vue-custom-scrollbar>
    </div>
    <div v-if="editable">
      <b-input-group class="mb-2 mt-2">
        <b-form-input
          v-model="note"
          :placeholder="$t('orders.notes.add')"
          @keyup.enter="addNote"
        />
        <b-input-group-append>
          <b-button variant="primary">
            <i
              class="fe fe-send align-middle"
              @click="addNote"
            />
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </div>
  </div>
</template>
<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
  name: 'OrderNotes',
  components: { vueCustomScrollbar },
  props: {
    notes: {
      type: Array,
      default () {
        return []
      },
    },
    editable: {
      type: Boolean,
      default () {
        return true
      },
    },
  },
  data () {
    return {
      note: undefined,
    }
  },
  watch: {
    notes: {
      handler () {
        this.$nextTick(() => {
          const container = this.$el.querySelector('#notes-container')
          container.scrollTop = container.scrollHeight
        })
      },
    },
  },
  methods: {
    addNote () {
      this.$emit('input', this.note)
      this.note = ''
    },
  },
}
</script>
<style lang="scss" module>
@import "./styles/notes.module.scss";
</style>
